// Header.jsx
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Search, Menu } from 'lucide-react';
import NotificationsDropdown from './NotificationsDropdown';
import useNotifications, { requestNotificationPermission } from '../hooks/useNotifications';
import { fetchUnreadCount } from '../features/notifications/notificationSlice';

const Header = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  
  // Initialize WebSocket connection
  useNotifications();

  // Request notification permission and fetch unread count on mount
  useEffect(() => {
    requestNotificationPermission();
    // Fetch initial unread count
    dispatch(fetchUnreadCount());
  }, [dispatch]);

  // Get employee profile photo and ID
  const employeePhoto = user?.employee_profile?.image;
  const employeeId = user?.employee_profile?.id;
  const employeeProfilePath = employeeId ? `/employees/${employeeId}` : '/employees';

  return (
    <header className="header">
      <div className="logo">
        <img src="/banner/logo.png" alt="Logo" />
      </div>


    

      {/* Right Section */}
      <div className="actions">
        
        
        {/* Notifications */}
        <NotificationsDropdown />
        
        {/* Avatar - Click to view profile */}
        <Link to={employeeProfilePath} className="avatar-link">
          <div className="avatar">
            {employeePhoto ? (
              <img 
                src={employeePhoto} 
                alt="Profile" 
                className="avatar-image"
              />
            ) : (
              <div className="avatar-placeholder">
                {user?.employee_profile?.first_name?.[0]?.toUpperCase() || 
                 user?.username?.[0]?.toUpperCase() || 'U'}
              </div>
            )}
          </div>
        </Link>
      </div>

      <style jsx>{`
        .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;
          width: 100%;
          box-sizing: border-box;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 999;
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border-bottom: 1px solid #f0f0f0;
        }
          
        .logo img {
          width: 98px;
        }

        .search-container {
          flex: 1;
          max-width: 400px;
        }

        .search-wrapper {
          width: 100%;
          position: relative;
        }

        .search-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          width: 16px;
          height: 16px;
          color: #9ca3af;
        }

        .search-input {
          width: 100%;
          padding: 8px 16px 8px 40px;
          background: #fff;
          border-radius: 20px;
          font-size: 14px;
          border: 1px solid #e5e7eb;
        }

        .search-input:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
        }

        .actions {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .menu-button {
          padding: 8px;
          border: none;
          background: transparent;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .menu-button:hover {
          background: #f3f4f6;
        }

        .menu-icon {
          width: 20px;
          height: 20px;
          color: #4b5563;
        }

        .avatar-link {
          text-decoration: none;
          display: flex;
          align-items: center;
        }

        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          background: linear-gradient(to right, #60a5fa, #2dd4bf);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .avatar:hover {
          transform: scale(1.05);
          box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
        }

        .avatar-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .avatar-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 600;
          color: white;
          background: linear-gradient(to right, #60a5fa, #2dd4bf);
        }
      `}</style>
    </header>
  );
};

export default Header;